import { render, staticRenderFns } from "./AppSecondary.vue?vue&type=template&id=179202e4&"
import script from "./AppSecondary.vue?vue&type=script&lang=js&"
export * from "./AppSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports